export const incomeList = [
  {Id: '1', Name: 'Rs. 0 - 1 Lakh'},
  {Id: '2', Name: 'Rs. 1 - 2 Lakh'},
  {Id: '3', Name: 'Rs. 2 - 3 Lakh'},
  {Id: '4', Name: 'Rs. 3 - 4 Lakh'},
  {Id: '5', Name: 'Rs. 4 - 5 Lakh'},
  {Id: '6', Name: 'Rs. 5 - 6 Lakh'},
  {Id: '7', Name: 'Rs. 6 - 7 Lakh'},
  {Id: '8', Name: 'Rs. 7 - 9 Lakh'},
  {Id: '9', Name: 'Rs. 9 - 10 Lakh'},
  {Id: '10', Name: 'Rs. 10 - 12 Lakh'},
  {Id: '11', Name: 'Rs. 12 - 15 Lakh'},
  {Id: '12', Name: 'Rs. 15 - 18 Lakh'},
  {Id: '13', Name: 'Rs. 18 - 20 Lakh'},
  {Id: '14', Name: 'Rs. 20 - 25 Lakh'},
  {Id: '15', Name: 'Rs. 25 - 30 Lakh'},
  {Id: '16', Name: 'Rs. 30 - 35 Lakh'},
  {Id: '17', Name: 'Rs. 35 - 40 Lakh'},
  {Id: '18', Name: 'Rs. 40 - 50 Lakh'},
  {Id: '19', Name: 'Rs. 50 - 60 Lakh'},
  {Id: '20', Name: 'Rs. 60 - 70 Lakh'},
  {Id: '21', Name: 'Rs. 70 - 80 Lakh'},
  {Id: '22', Name: 'Rs. 80 - 90 Lakh'},
  {Id: '23', Name: 'Rs. 90 Lakh - 1 crore'},
  {Id: '24', Name: 'Rs. 1 - 2 crore'},
  {Id: '27', Name: 'Rs. 2 - 3 crore'},
  {Id: '28', Name: 'Rs. 3 - 5 crore'},
  {Id: '29', Name: 'Rs. 5 - 10 crore'},
  {Id: '30', Name: 'Rs. 10 crore & above'},
  {Id: '31', Name: 'No Income'},
];
